<template>
	<div class="leftAside">
		<a :href="spRules.meiqia_url" class="aside-link" target="_blank">
			<span class="iconfont icon-kefu1 bounce"></span>
		</a>
		<div v-if="showScrollToTop" class="aside-link fade-in" @click="scrollToTop">
			<span class="iconfont icon-dingbu"></span>
		</div>
	</div>
</template>
<script>
	import helper from '@/common/helper.js';
	export default {
		data() {
			return {
				spRules: {},
				showScrollToTop: false, // New data property to control visibility
			};
		},
		methods: {
			scrollToTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				});
			},
			handleScroll() {
				// Check the scroll position and update showScrollToTop
				this.showScrollToTop = window.scrollY > 800;
			}
		},
		mounted() {
			this.spRules = this.$helper.get('rule');
			// Add scroll event listener
			window.addEventListener('scroll', this.handleScroll);
		},
		beforeDestroy() {
			// Clean up the event listener
			window.removeEventListener('scroll', this.handleScroll);
		}
	}
</script>
<style scoped>
	.fade-in {
		opacity: 1; /* Fully visible */
	}
	.leftAside{
		position: fixed;
		right: 10px;
		bottom: 20%;
		z-index: 22;
		height: 150px;
	}
	.leftAside .aside-link{
		display: flex;
		align-items: center;
		justify-content: center;
		width: 50px;
		height:50px;
		cursor: pointer;
		margin-bottom: 10px;
		color: #a66700;
	}
	.leftAside .aside-link .iconfont{
		font-size: 44px;
		display: inline-block;
	}
	
	
	@keyframes bounce {
	    0%,100%,20%,50%,80% {
	        -webkit-transform: translateY(0);
	        -ms-transform: translateY(0);
	        transform: translateY(0)
	    }
	
	    40% {
	        -webkit-transform: translateY(-10px);
	        -ms-transform: translateY(-10px);
	        transform: translateY(-10px)
	    }
	
	    60% {
	        -webkit-transform: translateY(-5px);
	        -ms-transform: translateY(-5px);
	        transform: translateY(-5px)
	    }
	}
	.bounce {
		-webkit-animation-iteration-count: 12;
		animation-iteration-count: 12;
	    -webkit-animation-name: bounce;
	    animation-name: bounce;
		-webkit-animation-duration: 2s;
		animation-duration: 2s;
		-webkit-animation-fill-mode: both;
		animation-fill-mode: both
	}
	
	
</style>

